import { PortalRole, UserProfile } from '.';

export function hasRole(profile: UserProfile, role: string): boolean {
  if (role === PortalRole[PortalRole.User]) {
    return (
      profile.role === PortalRole[PortalRole.User] ||
      profile.role === PortalRole[PortalRole.Admin]
    );
  }

  return profile.role === role;
}
